import { render, staticRenderFns } from "./Counterparties.vue?vue&type=template&id=1b8f5ffa"
import script from "./Counterparties.vue?vue&type=script&lang=ts"
export * from "./Counterparties.vue?vue&type=script&lang=ts"
import style0 from "./Counterparties.vue?vue&type=style&index=0&id=1b8f5ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports